<template>
  <div class="menuManagementList">
    <el-card class="location">
      <div class="divL">
        <el-button type="primary" @click="addMenu1">{{$t('lang.btn_addMenu1')}}</el-button>
        <el-button type="primary" @click="addMenu2">{{$t('lang.btn_addMenu2')}}</el-button>
        <el-button type="primary" @click="deleteMenu">{{$t('lang.btn_deleteMenu')}}</el-button>
        <el-form :label-suffix="require('@/config/enum').c_colon" class="form-padding">
          <el-form-item :label="$t('lang.lab_keyword')">
          <input style="display: none"/>
            <el-input
              class="inputkey"
              :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_keyword')"
              v-model="filterText"
              maxlength="20">
            </el-input> 
          </el-form-item>
        </el-form>
        <el-tree 
          class="filter-tree"
          ref="tree"
          :data="tableData" 
          :props="defaultProps"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="divR" v-if="this.isShowFlag">
        <!-- 一级菜单 -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" v-if="this.level === 0">
          <!-- 菜单名称 -->
          <el-form-item :label="$t('lang.lab_menuName')" prop="Name">
            <el-input v-model="ruleForm.Name" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_menuName')"  class="input-width" maxlength="50"></el-input>
          </el-form-item>
          <!-- 菜单来源 -->
          <el-form-item :label="$t('lang.lab_menuSource')" prop="Source">
            <el-select v-model="ruleForm.Source"  :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_menuSource')">
              <el-option
                v-for="item in sourceList"
                :key="item.id"
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_sort')" prop="Sort">
            <el-input v-model="ruleForm.Sort" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_sort')"  class="input-width" maxlength="50"></el-input>
          </el-form-item>
          <el-button class="btn-first" @click="resetForm()">{{$t('lang.btn_rest')}}</el-button>
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled" >{{$t('lang.btn_save')}}</el-button>
        </el-form>
        <!-- 二级菜单 -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" v-if="this.level === 1">
          <!-- 菜单名称 -->
          <el-form-item :label="$t('lang.lab_menuName')" prop="Name">
            <el-input v-model="ruleForm.Name" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_menuName')"  class="input-width" maxlength="50"></el-input>
          </el-form-item>
          <!-- 菜单来源 -->
          <el-form-item :label="$t('lang.lab_menuCode')" prop="Code">
            <el-input v-model="ruleForm.Code" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_menuCode')"  class="input-width" maxlength="50"></el-input>
          </el-form-item>
          <!-- 菜单链接 -->
          <el-form-item :label="$t('lang.lab_menuLink')" prop="LinkURL">
            <el-input v-model="ruleForm.LinkURL" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_menuLink')"  class="input-width"></el-input>
          </el-form-item>
          <!-- 查看范围 -->
          <el-form-item :label="$t('lang.lab_menuCheckGrade')" prop="CheckGrade" v-if="this.source === 1">
            <el-select v-model="ruleForm.CheckGrade"  :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_menuCheckGrade')">
              <el-option
                v-for="item in checkGradeList"
                :key="item.id"
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 应用图标 -->
          <el-form-item label="应用图标" prop="ImageUrl" ref="ImageUrl"  v-if="this.source === 2">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileList" :clears="clears"
              @outputFile="getFile" @removeFile="removeFile"></upload-file>
          </el-form-item>
          <el-button class="btn-first" @click="resetForm()">{{$t('lang.btn_rest')}}</el-button>
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:menuManagementList
 *@Description:菜单管理
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-20
 */
import UploadFile from '../../../components/upload_file.vue'
export default {
  data() {
    return {
      isDisabled: true, // 修改的可点击
      tableData: [], // menulist
      ruleForm: {
        Name: '', // 菜单名称
        Source: 1, // 菜单来源
        Code: '', // 菜单编码
        Sort:'',
        LinkURL: '', // 菜单链接
        CheckGrade: 2, // 查看范围
      }, // 添加内容
      filterText: '', // 关键词检索
      flag: '', // 菜单级别：1：一级 2：二级
      id: '', // tree id
      source: '', // tree source
      isMenuOne: false, // 用于判断，当前是否一级选中
      level: 2, // 菜单级别：0：一级 1：二级
      data: '', // 保存当前节点数据，用于删除时判断，当前节点下是否有子节点
      isAdd: false, // 添加状态：false：编辑或详情 true：添加
      isShowFlag: false, // 右侧显示状态：false：不显示 true：显示
      defaultProps: {
        children: 'children',
        label: 'name',
      }, // tree数据
      rules: {
        Name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_menuName'), trigger: 'blur' }],
        Source: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_menuSource'), trigger: 'blur' }],
        Sort: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_sort'), trigger: 'blur' }],
        Code: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_menuCode'), trigger: 'blur' }],
        LinkURL: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_menuLink'), trigger: 'blur' }],
        CheckGrade: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_menuCheckGrade'), trigger: 'blur' }],
      },
      checkGradeList: this.$i18n.t('lang.MenuManagementList_checkGradeList'), // 查看范围
      sourceList: this.$i18n.t('lang.MenuManagementList_sourceList'), // 菜单来源
      fileList: [], // 菜单应用图标列表
      clears: false, // 清空按钮
      accept: '.jpg, .jpeg, .png',
    }
  },
  components: {
    'upload-file': UploadFile
  },
  created() {
    this.getData()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取表格数据
    getData() {
      let loading = this.$loading()
      this.$get(`/getMunuList`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.result
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取子节点数据
    getTreeData() {
      this.fileList = []
      let loading = this.$loading()
      this.$get(`/getMunuInfo?id=${this.id}&level=${this.level}&source=${this.source}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res.result)
            this.ruleForm = res.result
            if (this.ruleForm.ImageUrl) {
              this.fileList.push({
                name: '',
                url: this.ruleForm.ImageUrl
              })
            }
            
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加一级菜单
    addMenu1() {
      // 用于判断是否可以添加二级
      this.isMenuOne = false
      // 初始化saveData
      this.saveData = JSON.stringify('')
      // 右侧显示状态
      this.isShowFlag = true
      // 添加状态
      this.isAdd = true
      // 清空信息
      let temp = {
        Name: '', // 菜单名称
        Source: 1, // 菜单来源
        Code: '', // 菜单编码
        LinkURL: '', // 菜单链接
        CheckGrade: ''// 查看范围
      }
      this.ruleForm = temp

      this.rules.Name[0].required = true
      this.rules.Source[0].required = true
      this.rules.Code[0].required = false
      this.rules.LinkURL[0].required = false
      this.rules.CheckGrade[0].required = false

      if (this.id != '') {
        this.$refs.ruleForm.clearValidate()
      }
      // 标识当前节点是几级菜单
      this.level = 0
      this.flag = 1
    },
    // 添加二级菜单
    addMenu2() {
      // 判断是否已经选中一级菜单
      if (!this.isMenuOne) {
        // 右侧显示状态
        this.isShowFlag = false
        this.isMenuOne = false
        this.level = 2
        this.id = ''
        this.$message.error(this.$i18n.t('lang.lab_selectMenuLevel1'))
        return
      }
      // 初始化saveData
      this.saveData = JSON.stringify('')
      // 右侧显示状态
      this.isShowFlag = true
      // 添加状态
      this.isAdd = true
      // 清空信息
      let temp = {
        Name: '', // 菜单名称
        Source: '', // 菜单来源
        Code: '', // 菜单编码
        LinkURL: '', // 菜单链接
        CheckGrade: 2// 查看范围
      }
      this.ruleForm = temp

      if (this.source === 2) {
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = false
        this.rules.CheckGrade[0].required = false
      } else {
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = true
        this.rules.CheckGrade[0].required = true
      }
      if (this.id != '') {
        this.$refs.ruleForm.clearValidate()
      }
      // 标识当前节点是几级菜单
      this.level = 1
      this.flag = 2

      this.ruleForm.MunuManagerId = this.id
    },
    // 保存
    save(formName) {
      let params1edit = { 
        'model': {
        'Id': this.ruleForm.Id,
        'Name': this.ruleForm.Name,
        'Sort': this.ruleForm.Sort,
        'Source': this.ruleForm.Source
        },
        'flag': this.flag,
      }
      let params1add = { 
        'model': {       
        'Name': this.ruleForm.Name,
        'Sort': this.ruleForm.Sort,
        'Source': this.ruleForm.Source
        },
        'flag': this.flag,
      }
      let params2edit1 = { 
        'model': {
          'Id': this.ruleForm.Id,
          'MunuManagerId': this.ruleForm.MunuManagerId,
          'Name': this.ruleForm.Name,
          'Code': this.ruleForm.Code,
          'LinkURL': this.ruleForm.LinkURL,
          'CheckGrade': this.ruleForm.CheckGrade,
        },
        'flag': this.flag,
        'source': this.source,
      }
      let params2edit2 = { 
        'model': { 
          'Id': this.ruleForm.Id,
          'MunuManagerId': this.ruleForm.MunuManagerId,
          'Name': this.ruleForm.Name,
          'Code': this.ruleForm.Code,
          'CheckGrade': 2,
          'LinkURL': this.ruleForm.LinkURL,
          'ImageUrl': this.ruleForm.ImageUrl,
        },
        'flag': this.flag,
        'source': this.source,
      }
      let params2add1 = { 
        'model': { 
          'MunuManagerId': this.ruleForm.MunuManagerId,
          'Name': this.ruleForm.Name,
          'Code': this.ruleForm.Code,
          'LinkURL': this.ruleForm.LinkURL,
          'CheckGrade': this.ruleForm.CheckGrade
        },
        'flag': this.flag,
        'source': this.source,
      }
      let params2add2 = { 
        'model': {
          'MunuManagerId': this.ruleForm.MunuManagerId,
          'Name': this.ruleForm.Name,
          'Code': this.ruleForm.Code,
          'CheckGrade': 2,
          'LinkURL': this.ruleForm.LinkURL,
          'ImageUrl': this.ruleForm.ImageUrl,
          },
        'flag': this.flag,
        'source': this.source,
      }
      let params = { }
      if (this.flag === 1) {
        if (this.isDisabled === false && this.isAdd === false) {
          params = params1edit
        } else {
          params = params1add
        }
      } else {
        if (this.isDisabled === false && this.isAdd === false) {
          if (this.source === 1) {
            params = params2edit1
          } else {
            params = params2edit2
          }
        } else {
          if (this.source === 1) {
            params = params2add1
          } else {
            params = params2add2
          }
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$postJson('/AOEMunu', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_add_success'))
                this.getServerInfo()
                this.isShowFlag = false
                this.isMenuOne = false
                this.level = 2
                this.id = ''
                this.saveData = JSON.stringify('')
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 清空
    resetForm() {
      if (this.flag === 1) {
        this.ruleForm.Name = '' // 菜单名称
        this.ruleForm.Source = 1 // 菜单来源
        this.rules.Name[0].required = true
        this.rules.Source[0].required = true
        this.rules.Code[0].required = false
        this.rules.LinkURL[0].required = false
        this.rules.CheckGrade[0].required = false
      } else if (this.flag === 2 && this.source === 2) {
        this.ruleForm.Name = '' // 菜单名称
        this.ruleForm.Code = '' // 菜单编码
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = false
        this.rules.CheckGrade[0].required = false
      } else if (this.flag === 2 && this.source === 1) {
        this.ruleForm.Name = '' // 菜单名称
        this.ruleForm.Code = '' // 菜单编码
        this.ruleForm.LinkURL = '' // 菜单链接
        this.ruleForm.CheckGrade = 2 // 查看范围
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = true
        this.rules.CheckGrade[0].required = true
      }
      this.$refs.ruleForm.clearValidate()
    },
    // 更新服务器内容
    getServerInfo() {
      let loading = this.$loading()
      this.$get(`/getServerInfo`).then(
        res => {
          loading.close()
          if (res) {
            console.log('getServerInfo', res)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
      this.getData()
    },
    // 删除菜单
    deleteMenu() {
      console.log(this.ruleForm.Id, this.level, this.data.children)
      // 请选择一个菜单！
      if (this.ruleForm.Id === undefined || this.level === 2) {
        this.$message.error(this.$i18n.t('lang.lab_select1Menu'))
        return
      }
      // 当前菜单下有子菜单，请先删除子菜单！
      if (this.data.children != null && this.data.children.length > 0) {
        this.$message.error(this.$i18n.t('lang.lab_theMenuHaveChildren'))
        return       
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          let params = {
            Id: this.ruleForm.Id,
            Flag: this.flag,     
          }
          this.$patch(`/delMunu`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.getServerInfo()
                this.isShowFlag = false
                this.isMenuOne = false
                this.level = 2
                this.id = ''
                this.saveData = JSON.stringify('')
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 点击tree节点
    handleNodeClick(data) {
      console.log('handleNodeClick')
      // 右侧显示状态
      this.isShowFlag = true
      // 添加状态
      this.isAdd = false
      // 判断当前节点是几级菜单：没有children元素的是二级菜单
      if (data.children === undefined) {
        // 用于判断是否可以添加二级
        this.isMenuOne = false
        // 二级菜单level为1
        this.level = 1
        // 一级菜单对应的值，保存用
        this.flag = 2
      } else {
        // 用于判断是否可以添加二级
        this.isMenuOne = true
        // 一级菜单level为0
        this.level = 0
        // 一级菜单对应的值，保存用
        this.flag = 1
      }
      // 表单验证
      if (this.flag === 1) {
        this.rules.Name[0].required = true
        this.rules.Source[0].required = true
        this.rules.Code[0].required = false
        this.rules.LinkURL[0].required = false
        this.rules.CheckGrade[0].required = false
      } else if (this.flag === 2 && this.source === 2) {
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = false
        this.rules.CheckGrade[0].required = false
      } else if (this.flag === 2 && this.source === 1) {
        this.rules.Name[0].required = true
        this.rules.Source[0].required = false
        this.rules.Code[0].required = true
        this.rules.LinkURL[0].required = true
        this.rules.CheckGrade[0].required = true
      }
      if (this.id != '') {
        this.$refs.ruleForm.clearValidate()
      }
      // 当前节点id
      this.id = data.id
      // 来源为0是手机APP，保存用
      this.source = data.source
      // 用于判断是否可以删除
      this.data = data
      // 获取数据
      this.getTreeData()
    }, 
    // 关键字
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) != -1
    },
    // 获取组件值
    getFile(e) {
      this.ruleForm.ImageUrl = e
      this.$refs.ImageUrl.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.ruleForm.ImageUrl = ''
    },
  }
}
</script>

<style lang='scss'>
.menuManagementList {
  .location{
    padding: 40px;
  }
  .form-padding{
    padding-top: 20px;
  }
  .divL{
    width: 40%;
    float: left;
  }
  .divR{
    width: 60%;
    float: right;
  }
  .inputkey{
    width: 60%;
  }
  .input-width{
    width: 50%;
  }
}
</style>